<template>
  <el-dialog title="基本信息" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="18">
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="tenantname" style="width: 70%">
          <el-input v-model="form.tenantname" auto-complete="off" :required="true"></el-input>
        </el-form-item>

      </el-row>
      <el-row :gutter="18">
        <el-form-item label="网址：" :label-width="formLabelWidth" prop="website" style="width: 70%">
          <el-input v-model="form.website" auto-complete="off" :required="true" placeholder="格式：vue.zyanjing.com"></el-input>
        </el-form-item>
      </el-row>
      <!--<el-row :gutter="18">-->
        <!--<el-form-item label="接口地址：" :label-width="formLabelWidth" prop="appurl">-->
          <!--<el-input v-model="form.appurl" auto-complete="off" :required="true"></el-input>-->
        <!--</el-form-item>-->
      <!--</el-row>-->
      <el-row :gutter="18">
        <el-col :span="9">
        <el-form-item label="管理员：" :label-width="formLabelWidth" prop="contactname" style="width: 70%">
          <el-input v-model="form.contactname" auto-complete="off" :required="true"
                    :disabled="form.unitguid?true:false"></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="9">
        <el-form-item label="手机号：" :label-width="formLabelWidth" prop="contactphone" style="width: 70%">
          <el-input v-model="form.contactphone" auto-complete="off" :required="true"
                    :disabled="form.unitguid?true:false"></el-input>
        </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="18">
        <el-col :span="12">
          <el-form-item label="" :label-width="formLabelWidth">
            <el-radio-group v-model="form.ifuseaccount">
              <el-radio :label="0">批发商</el-radio>
              <el-radio :label="1">镜架供应商</el-radio>
              <el-radio :label="2">镜片供应商</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="18" v-if="form.ifuseaccount!=0">
        <el-col :span="18" v-if="form.ifuseaccount!=0">
          <el-form-item label="经营品牌：" :label-width="formLabelWidth" prop="categoryname">
            <CommonTree ref="treeUsersMain" :isShowCheckBox="true" :treeHeight="200" :treeWidth="266"
                        :searchText="form.categoryname" :expandonclicknode="true" :defineDataSource="true"
                        :defaultCheckedKeys="form.account" @check="checktreeGoods" :multipleSplicing="true"
                        @bindData="bindGoodsData"></CommonTree>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="18" v-if="form.ifuseaccount==0">
        <el-col :span="9">
          <el-form-item label="平台使用费：" :label-width="formLabelWidth" prop="platformlicensing" style="width: 70%">
            <el-input-number v-model="form.platformlicensing" :controls="false"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="期限：" :label-width="formLabelWidth" prop="enddatetime" style="width: 70%">
            <el-date-picker
              v-model="form.enddatetime"
              type="date" :clearable="false"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="18" v-if="form.ifuseaccount==0">
          <el-form-item label="续费记录：" :label-width="formLabelWidth">
            <el-table
              :data="payData"
              size="mini"
              stripe
              border
              style="width: 100%;">

              <el-table-column
                width="50"
                label="序号"
                align="center" fixed>
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="时间" width="140" fixed>
                <template slot-scope="scope">
                  {{(scope.row.adddate || "").substr(0, 19)}}
                </template>
              </el-table-column>
              <el-table-column
                label="支付金额"
                align="right"
                header-align="center"
                width="130" fixed
              >
                <template slot-scope="scope">
                  {{scope.row.credit | numeric(2)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="paymethod"
                label="方式"
                align="center"
                width="110">
              </el-table-column>
              <!--<el-table-column-->
                <!--prop="erpserial"-->
                <!--label="订单号"-->
                <!--align="center"-->
                <!--width="140"-->
              <!--&gt;-->
              <!--</el-table-column>-->
              <el-table-column
                prop="rechargeserial"
                label="支付流水号"
                align="center"
                width="220">
              </el-table-column>
            </el-table>
          </el-form-item>
      </el-row>
      <el-row :gutter="18" v-if="false">
        <el-col :span="9">
          <el-form-item label="开通用户数：" :label-width="formLabelWidth" prop="registereduser" style="width: 70%">
            <el-input-number v-model="form.registereduser" :min="1"
                             :disabled="form.unitguid?true:false"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="授权用户数：" :label-width="formLabelWidth" prop="authorizeuser" style="width: 70%">
            <el-input-number v-model="form.authorizeuser" :min="1"
                             :disabled="form.unitguid?true:false"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="false">

        <el-col :span="8">
          <el-form-item label="使用存货：" :label-width="formLabelWidth" prop="ifusestore">
            <el-radio-group v-model="form.ifusestore" :disabled="form.unitguid?true:false">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="18" v-if="false">
          <el-form-item label="启用会员：" :label-width="formLabelWidth" prop="ifusemember">
            <el-radio-group v-model="form.ifusemember" :disabled="form.unitguid?true:false">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        <el-form-item label="会员名称：" :label-width="formLabelWidth" prop="membername" style="width: 70%">
          <el-input v-model="form.membername" auto-complete="off" :required="true"
                    :disabled="form.unitguid?true:false"></el-input>
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">关 闭</el-button>
      <el-button type="primary" @click="saveData" :loading="CanEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {sysmanagesaveData, sysmanageDetail} from '@/api/sysmanage/sysmanage';
  import {getListData} from '@/api/set/recharge';
  import {getGoodsTree} from '@/api/set/jxcgooddetail';


  export default {
    name: "ManageTenantEdit",
    data() {
      return {
        dialogFormVisible: false,
        CanEdit: false,//防止多次提交
        payData:[],
        form: {  //表单数据
          unitguid: '',
          tenantname: '',//名称
          categoryname:'',
          website: '',//网址
          account:'',
          contactname: '',//管理员
          contactphone: '',//手机号
          registereduser: '',//开通用户数
          authorizeuser: '',//授权用户数
          platformlicensing:'',
          enddatetime:'',
          ifuseaccount: 0,//是否启用总账0 否  1 是
          ifusemember: 1,//启用会员系统 0 否  1 是
          membername: '',//会员系统名称
          ifusestore: 0,//是否使用存货管理 0 否  1 是
        },
        formLabelWidth: '120px',
        radio: [{label: 1, name: '是'}, {label: 0, name: '否'}],
        rules: {////////定义正则验证字段。
          tenantname: [
            {required: true, message: '请输入名称', trigger: 'blur'},
          ],
          website: [
            {required: true, message: '请输入网址', trigger: 'blur'},
          ],
          contactname: [
            {required: true, message: '请输入管理员', trigger: 'blur'},
          ],
          contactphone: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
          ],
        },
      }
    },
    methods: {
      checktreeGoods(guids, names, arr) {
        this.form.account = guids
        this.form.categoryname = names
      },
      bindGoodsData() {
        this.$refs.treeUsersMain.bindData(() => {
          return getGoodsTree({onlyShowGroupType: true, categorymaxlenght: 9})
        })
      },
      show() {
        this.dialogFormVisible = true
        this.initForm()
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.CanEdit = true
            if(this.form.ifuseaccount==0) {
              this.form.account = ''
            }
            sysmanagesaveData(this.form).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.dialogFormVisible = false
                //刷新列表
                this.$emit('bindGuid');
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
                this.CanEdit = false
              }
            });
          }
        })
      },
      initData(unitguid) {
        this.form.unitguid = unitguid
        sysmanageDetail({unitguid: unitguid}).then(response => {
          for (let i in this.form) {
              this.form[i] = response.data.obj[i]
          }
        });
        this.listPay();
      },
      listPay() {
        this.payData=[]
        getListData({customerserial: this.form.unitguid,beginDate:'2021-01-01',endDate:'2121-01-01'}).then(response => {
          this.payData = response.data.obj;
        })
      },
      initForm() {
        for (let i in this.form) {
          this.form[i] = ""
        }
        this.form.ifuseaccount = 0
        this.form.ifusemember = 1
        this.form.ifusestore = 0
        this.CanEdit = false
      },
    },
    mounted() {
    },
    components: {}
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {
    text-align: center;
  }

  .query-table td.mainlink {
    font-weight: bold;
  }

  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }

  .serverAlertCss {
    line-height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sysmanage/managgetenant/ManageTenantEdit.vue